import React, { SyntheticEvent } from "react";
import { Box, Tab, Tabs, Button, Typography, Paper, Pagination, styled } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import RoutineStyle from "../../GlobalPolicies/RoutineUpload.module.css";

interface   ValueCreationGbsCrossTabsProps {
  tabValue: string;
  handleTabChange: (event: React.SyntheticEvent, newValue: string) => void;
  tabStatuses: { label: string; value: 'All' | 'Pending' | 'Approved' | 'Reverted'; apiStatus: string | null }[];
  counts: { All: number; Pending: number; Approved: number; Reverted: number };
  verticalTabValue: string;
  verticalTabs: { label: string; value: string }[];
  isLoading: boolean;
  filteredRoutineData: any[];
  paginatedData: any[];
  routineData: any[];
  itemsPerPage: number;
  handleChangePage: (event: React.ChangeEvent<unknown>, value: number) => void;
  handleViewClick: (id: any, file_name: string, function_l1: any, created_at: any, updated_at: any, updated_by: any, status: any, reason_to_approve: any, reason_to_revert: any) => void;
  setOpenUpload: (open: boolean) => void;
  getFileImagePath: (doc_path: string) => string;
  handleVerticalTabChange?: (event: React.SyntheticEvent, newValue: string) => void;
  isMcrTab?: boolean;
  question?:any;
}

const StyledTableRow = styled(Box)<{ status: string }>(({ status }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: '10px',
  boxShadow: `4px 0px 0px 0px ${status === 'Approved'
    ? '#058B2B'
    : status === 'Reverted'
      ? '#e53935'
      : status === 'Pending'
        ? '#FF5C00'
        : 'transparent'
    } inset`,
}));

const  ValueCreationGbsCrossTabs: React.FC<  ValueCreationGbsCrossTabsProps> = ({
  tabValue,
  handleTabChange,
  tabStatuses,
  counts,
  verticalTabValue,
  verticalTabs,
  isLoading,
  filteredRoutineData,
  paginatedData,
  routineData,
  itemsPerPage,
  handleChangePage,
  handleViewClick,
  setOpenUpload,
  getFileImagePath,
  handleVerticalTabChange,
  isMcrTab,
  question
}) => {
  const management = localStorage.getItem('management') || '';
  const apiManagement = localStorage.getItem('apiManagement') || '';
  const isManagementMatching = management === apiManagement;

  console.log('Current verticalTabValue:', verticalTabValue); // Add this


  

  const getFileDescription = () => {

    switch (verticalTabValue) {
      case "a":
        return "Please upload signed ICO contracts & markup email confirmation from global tax and service receiving zone. As well as markup research provided by external consultant.";
      case "b":
        return "Evidence should include all required documentation as per policy on time.";

      default:
        return "Upload file";
    }
  };

  const getFileQuestions = (verticalTabValue: string) => {
    switch (verticalTabValue) {
      case "a":
        return "Question : ICO (Intercompany contracts) are existing, validated by Global and Zone Tax, Legal functions (and other if applicable) and signed-off in line with DAG with mark-up aligned between service receiving and service providing entity. Reviewed yearly.";
      case "b":
        return "Question : Cross-charge process is executed as per process steps stipulated in GBS Cross-charge Policy, incl. performance reporting and statutory invoicing, required frequency, FX impact treatment etc. (applicaple for GBS services).";
   
      default:
        return null;
    }
  };

 



  const renderNoFilesContent = () => (
    <Box sx={{ textAlign: 'center', p: 2 }}>
     <Typography variant="h6" sx={{textAlign:'center'}}>
        There's no file uploaded right now
      </Typography>
      <Typography sx={{ mb: 2 }}>
        {getFileDescription()}

      </Typography>
      <Button
        variant="contained"
        className={RoutineStyle.border_btn}
        onClick={() => setOpenUpload(true)}
        disabled={!isManagementMatching}
      >
        Upload
      </Button>
    </Box>
  );

  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={tabValue}>
        <Box sx={{ display: "flex", justifyContent: "space-between", borderColor: "divider" }}>
          <Box className={RoutineStyle.tabs_routine}>
            <TabList onChange={handleTabChange} aria-label="SIPOC Tabs">
              {tabStatuses.map((tab) => (
                <Tab
                  key={tab.value}
                  label={`${tab.label} (${counts[tab.value] || 0})`}
                  value={String(tabStatuses.indexOf(tab) + 1)}
                  sx={{ textTransform: 'none', fontWeight: '400' }}
                />
              ))}
            </TabList>
            <Button
              variant="contained"
              className={RoutineStyle.uploadBtn}
              onClick={() => setOpenUpload(true)}
              disabled={!isManagementMatching}
            >
              Upload
            </Button>
          </Box>
        </Box>

        <TabPanel value={tabValue}>
          <Box sx={{ display: "flex" }}>
            {isMcrTab && (
              <Tabs
                orientation="vertical"
                variant="scrollable"
                value={verticalTabValue}
                onChange={handleVerticalTabChange}
                aria-label="Vertical Tabs"
                sx={{ minWidth: "150px", textAlign: 'left' }}
                className="vertical_rTabs"
              >
                {verticalTabs.map((tab) => (
                  <Tab key={tab.value} label={tab.label} value={tab.value} />
                ))}
              </Tabs>
            )}

            {isLoading ? (
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  textAlign: "center",
                  backgroundColor: "transparent",
                  height: "600px",
                  pt: 0,
                }}
              >
                <Typography className={RoutineStyle.noFileText}>
                  Fetching Files...
                </Typography>
              </Paper>
            ) : (
              <Box sx={{ marginLeft: 2, flexGrow: 1 }}>
                <Paper
                  elevation={0}
                  sx={{
                    // textAlign: "center",
                    backgroundColor: "transparent",
                    maxHeight: "600px",
                    pt: 0,
                  }}
                >
                  <Typography className={RoutineStyle.routineHeading}>
                    {verticalTabs.find((tab) => tab.value === verticalTabValue)?.label}
                  </Typography>

                  <Typography sx={{ color: '#000', fontSize: '16px', pb:2 }}>
                  {getFileQuestions(verticalTabValue)}
                                        
                                    </Typography>

                    {counts[tabStatuses[Number(tabValue) - 1].value] === 0 ? (
                     <Box sx={{ textAlign: 'center', p: 2, display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center', height:'500px' }}>
                     <Typography variant="h6" sx={{textAlign:'center'}}>
                        There's no file uploaded right now
                      </Typography>
                      <Typography sx={{ mb: 2 }}>
                        {getFileDescription()}
                      </Typography>
                      <Button
                        variant="contained"
                        className={RoutineStyle.border_btn}
                        onClick={() => setOpenUpload(true)}
                        disabled={!isManagementMatching}
                      >
                        Upload
                      </Button>
                    </Box>
                    ) : filteredRoutineData.length > 0 ? (
                      <>
                        {paginatedData.map((item) => (
                           <StyledTableRow sx={{ mb: 2}} status={item.status}>
                          <Paper key={item.id} className={RoutineStyle.bordercard} sx={{ width:'100%' }}>
                            <Box sx={{ display: "flex", gap: "50px", p: 2 }}>
                              <div style={{ display: "flex", textAlign: "left", gap: "5px", width: "40%" }}>
                                <div>
                                  <img src={getFileImagePath(item.doc_path)} alt="File" height={50} width={50} />
                                </div>
                                <div>
                                  <p>{item.file_name.split("_").slice(5).join("_")}</p>
                                  <h4>{item.file_size || "Unknown Size"}</h4>
                                </div>
                              </div>

                              {item.function_l1 && (
                                 <div style={{ textAlign: "left", width: "20%" }}>
                                 <h4>Function L1</h4>
                                 <p>{item.function_l1}</p>
                               </div>
                              )}

                             
                              <div style={{ textAlign: "left", width: "20%"}}>
                                <h4>Updated Date</h4>
                                <p>{new Date(item.created_at).toLocaleDateString()}</p>
                              </div>
                              <div style={{ textAlign: "left" }}>
                                <h4>Status</h4>
                                <p
                                  className={RoutineStyle.statuspending}
                                  style={{
                                    color:
                                      item.status === 'Reverted'
                                        ? '#F00'
                                        : item.status === 'Approved'
                                          ? '#058B2B'
                                          : item.status === 'Pending'
                                            ? '#FF5C00'
                                            : '#000',
                                  }}
                                >
                                  {item.status}
                                </p>
                              </div>
                            </Box>
                            <hr />

                            {(item.status === "Approved" || item.status === "Reverted") && (
                              <Box sx={{ padding: '10px' }}>
                                <Paper
                                  elevation={1}
                                  sx={{
                                    textAlign: 'left',
                                    borderRadius: '6px',
                                    border: `1px solid ${item.status === 'Reverted' ? 'red' : '#058B2B'}`,
                                    backgroundColor: item.status === 'Reverted' ? '#ffebeb' : '#e6ffed',
                                    padding: '10px',
                                  }}
                                >
                                  <Typography
                                    sx={{
                                      color: item.status === 'Reverted' ? 'red' : '#058B2B',
                                    }}
                                  >
                                    {item.status === "Approved" ? "Approved Reason" : "Reverted Reason"}
                                  </Typography>
                                  <Typography sx={{ paddingTop: '6px' }}>
                                    {item.status === "Approved" ? item.reason_to_approve : item.reason_to_revert}
                                  </Typography>
                                </Paper>
                              </Box>
                            )}

                            <Box sx={{ display: "flex", justifyContent: "flex-end", padding: "10px", borderRadius: "9px" }}>
                              <Button onClick={() => handleViewClick(item.id, item.file_name, item.function_l1, item.created_at, item.updated_at, item.updated_by, item.status, item.reason_to_approve, item.reason_to_revert)} className={RoutineStyle.black_btn}>
                                View
                              </Button>
                            </Box>
                          </Paper>
                        </StyledTableRow>
                      ))}

                      {filteredRoutineData.length > 3 && (
                        <Pagination
                          color="primary"
                          count={Math.ceil(filteredRoutineData.length / itemsPerPage)}
                          onChange={handleChangePage}
                          sx={{
                            display: "flex",
                            justifyContent: "center",
                            mt: 2,
                            "& .MuiPaginationItem-root": {
                              color: "black",
                            },
                            "& .MuiPaginationItem-ellipsis": {
                              color: "black",
                            },
                            "& .MuiPaginationItem-icon": {
                              color: "black",
                            },
                          }}
                        />
                      )}
                    </>
                  ) : (
                    renderNoFilesContent()
                  )}
                </Paper>
              </Box>
            )}
          </Box>
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default  ValueCreationGbsCrossTabs;